<template>
    <div class="page-list mb-5 mx-2">
		<h1 class="mb-3">Page Editor</h1>
       <div class="mb-3">
			<div class="card mb-3 table-card">
				<div class="card-header">
					<div class="row">
						<div class="col-md-6 col-12">
							<h3 class="mt-2">Pages ({{ filtered_pages.length }})</h3>
						</div>

						<div class="col-md-6 d-none d-md-block">
							<div class="d-flex justify-content-end justify-self-end gap-2">
								<div class="position-relative">
									<input type="text" placeholder="Search by Title..." aria-label="Search by Title..." v-model="search_key" @input="handleFilterSelection" autocomplete="one-time-code" class="search-box form-control me-1 py-2">
									<i class="fa fa-search search-placeholder-icon" v-show="search_key === ''"></i>
								</div>
								<a class="btn btn-primary float-end" href="/admin/pages/new">
									<i class="fa fas fa-fw fa-plus"></i> Add Page
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body p-0">
                    <div class="table-width-responsive">
						<table class="table table-with-pagination mb-0">
							<thead>
								<tr class="table-header-row">
									<th @click.prevent="sortByKey('title')" class="d-table-cell">
										<div class="d-flex flex-row">
											Title
											<div class="d-flex flex-column">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'title' && sort_order === 'asc' }" alt="">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'title' && sort_order === 'des' }" alt="">
											</div>
										</div>
									</th>
									<th @click.prevent="sortByKey('slug')" class="d-none d-md-table-cell">
										<div class="d-flex flex-row">
											Slug
											<div class="d-flex flex-column">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'slug' && sort_order === 'asc' }" alt="">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'slug' && sort_order === 'des' }" alt="">
											</div>
										</div>
									</th>
									<th @click.prevent="sortByKey('updated_at')" class="d-none d-md-table-cell">
										<div class="d-flex flex-row">
											Updated At
											<div class="d-flex flex-column">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'updated_at' && sort_order === 'asc' }" alt="">
												<img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'updated_at' && sort_order === 'des' }" alt="">
											</div>
										</div>
									</th>
									<th class="d-table-cell column-sort-disabled text-center pe-3" width="1">
										<div class="d-flex flex-row">
											Actions
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(page, index) in list_shown" :key="page.id">
									<td class="d-table-cell align-start p-1">
										<a :href="`/admin/pages/${page.id}/edit`">{{ page.title }}</a>
									</td>
									<td class="d-none d-md-table-cell">
										<a :href="`/pages/${page.slug}`" target="_blank">{{ page.slug }}</a>
									</td>
									<td class="d-table-cell">
										{{ datetime(page.updated_at) }}
									</td>
									<td class="table-column-action d-table-cel">
										<div class="dropdown d-flex justify-content-center">
											<button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
												<img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="" />
											</button>
											<div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
												<a class="dropdown-item" :href="`/admin/pages/${page.id}/edit`">
													<img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit Page
												</a>
												<a class="dropdown-item" :href="`/pages/${page.slug}`">
													<img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> Preview Page
												</a>
												<hr class="my-1" />
												<a class="dropdown-item text-danger" href="#" @click.prevent="deletePage(page)">
													<img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete Page
												</a>
											</div>
										</div>
									</td>
								</tr>
								<tr v-if="list_shown.length === 0">
									<td colspan="4" class="text-center py-3">No pages found. <a href="/admin/pages/new">Create your first page</a>.</td>
								</tr>
							</tbody>
							<tfoot class="table-border-bottom-0">
								<tr>
									<td colspan="100%" class="py-0">
										<div class="table-pagination">
											<div class="table-pagination--group d-none d-md-flex">
												<div class="position-relative">
													<select class="form-select" v-model="num_per_page" @update:modelValue="reloadPagination(filtered_pages)" aria-label="Num Per Page">
														<option value="5000">ALL</option>
														<option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
													</select>
													<div class="select-display-text">
														Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
													</div>
												</div>
												<div class="position-relative">
													<select class="form-select" v-model="num_per_page" @update:modelValue="reloadPagination(filtered_pages)" aria-label="Num Per Page">
														<option value="5000">ALL</option>
														<option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
													</select>
													<div class="select-display-text">
														Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
													</div>
												</div>
											</div>

											<div class="table-pagination--group d-none d-lg-flex">
												{{ filtered_pages.length ==0 ? '0' : item_interval }} of {{ filtered_pages.length }}
											</div>

											<div class="table-pagination--group">
												<button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click.prevent="moveToPrevPage(filtered_pages)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
													<img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
												</button>

												<div class="d-flex page-selector" v-if="page_index_array.length <= 3">
													<button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click.prevent="moveToPage(page, filtered_pages)">
														{{ page }}
													</button>
												</div>
												<div class="d-flex page-selector" v-else>
													<button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click.prevent="moveToPage(page, filtered_pages)">
														{{ page }}
													</button>

													<button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
													...
													</button>
													<button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
														{{ page_index + 1 }}
													</button>

													<button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
													...
													</button>
													<button :class="page_index === (page_index_array.length -1) ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click.prevent="moveToPage(page_index_array.length, filtered_pages)" :key="page_index_array.length">
														{{ page_index_array.length }}
													</button>
												</div>

												<button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click.prevent="moveToNextPage(filtered_pages)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
													<img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
												</button>
											</div>
										</div>
									</td>
								</tr>
							</tfoot>
						</table>                        
                    </div>

				</div>
			</div>
		</div>
   </div>
</template>

<script>
import tablePaginationMixin from '../../mixins/table_pagination';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';

export default {
	name: 'PageList',
	props: {
		pages: {
			type: Array,
			default: () => []
		}
	},
	mixins: [tablePaginationMixin],
	setup() {
		const { showNotification } = useNotifications();
		return {
			showNotification
		};
	},
	data() {
		return {
			filtered_pages: [],
			list_shown: [],
			search_key: '',
			sort_key: 'title',
			sort_order: 'asc'
		};
	},
	beforeMount() {
		this.filtered_pages = [...this.pages];
		this.reloadPagination(this.filtered_pages);
	},
	methods: {
		handleFilterSelection() {
			const searchTerm = this.search_key.trim().toLowerCase();
			const filtered_list = this.pages.filter(page => {
				if (!searchTerm) return true;
				return page.title.toLowerCase().includes(searchTerm) ||
					page.slug.toLowerCase().includes(searchTerm);
			});

			this.filtered_pages = filtered_list;
			this.sortData();
			this.reloadPagination(this.filtered_pages);
		},
		sortByKey(key) {
			if (this.sort_key === key) {
				this.sort_order = this.sort_order === 'asc' ? 'des' : 'asc';
			} else {
				this.sort_key = key;
				this.sort_order = 'asc';
			}
			this.sortData();
		},
		sortData() {
			this.filtered_pages.sort((a, b) => {
				const comparison = a[this.sort_key].localeCompare(b[this.sort_key]);
				return this.sort_order === 'asc' ? comparison : -comparison;
			});
			this.reloadPagination(this.filtered_pages);
		},
		async deletePage(page) {
			const result = await Swal.fire({
				title: "Are you sure you want to delete this page?",
				text: "This action cannot be undone.",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, delete it",
				customClass: {
					popup: 'swal-warning'
				}
			});

			if (result.isConfirmed) {
				try {
					await window.axios.delete(`/api/pages/${page.id}`);
					
					this.filtered_pages = this.filtered_pages.filter(p => p.id !== page.id);
					this.pages = this.pages.filter(p => p.id !== page.id);
					this.reloadPagination(this.filtered_pages);

					this.showNotification({
						text: '<strong>' + page.title + '</strong> was deleted!'
					});
				} catch (error) {
					this.showNotification({
						text: 'Failed to delete <strong>' + page.title + '</strong>. Please try again.',
						type: 'error'
					});
				}
			}
		}
	}
};
</script>